import { css } from '@emotion/react';
import { Box } from '@spark-web/box';
import { Container } from '@spark-web/container';
import { Heading } from '@spark-web/heading';
import { ChevronUpIcon } from '@spark-web/icon';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button as BrighteButton } from '~/components/common/button';
import { PARTNER_DISCLAIMER } from '~/constants';
import { MarketplacePartner } from '~/types/marketplace';

type PartnerDisclaimerProps = {
  partner?: MarketplacePartner;
};

export const PartnerDisclaimer: FC<PartnerDisclaimerProps> = ({ partner }) => {
  const { t } = useTranslation();

  const onScrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });

    const mainContent = document.querySelector('main');
    if (mainContent) {
      mainContent.focus();
    }
  };

  const partnerDisclaimer = partner && partner in PARTNER_DISCLAIMER ? PARTNER_DISCLAIMER[partner]?.(t) : false;

  return partnerDisclaimer ? (
    <Box display="flex" flex={1}>
      <Container size="large">
        <Stack
          gap="xxlarge"
          position="relative"
          paddingY="xxlarge"
          marginBottom="xxlarge"
          flex={1}
          paddingX="large"
          height="full"
        >
          <Box display="flex" flexDirection="column" gap="xxlarge">
            <Box
              display="flex"
              css={css({
                flex: 2,
              })}
            >
              <Heading level="2">{partnerDisclaimer.title}</Heading>
            </Box>
            <Box
              display="flex"
              marginTop="medium"
              css={css({
                flex: 4,
              })}
            >
              <Text size="xsmall">{partnerDisclaimer.content}</Text>
            </Box>
          </Box>

          <Stack
            position="absolute"
            css={css({
              bottom: -25,
              right: 'calc(5% + 10px)',
            })}
          >
            <BrighteButton
              label="back to top"
              size="medium"
              css={css({
                borderRadius: 0,
              })}
              onClick={onScrollUp}
            >
              <ChevronUpIcon tone="neutral" />
            </BrighteButton>
          </Stack>
        </Stack>
      </Container>
    </Box>
  ) : null;
};
